import { render } from "./Footer.vue?vue&type=template&id=5be5fa36&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5be5fa36&lang=scss&scoped=true"

import exportComponent from "/Users/wlp9071/workspace/szbProject/lnyx/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be5fa36"]])

export default __exports__